export default "__VITE_ASSET__Br7wPmkl__"